import { acceptHMRUpdate, defineStore } from 'pinia'

import { type CaseSourceName, type CaseType, type DataSource } from '~/types.ts'

export const useDataSources = defineStore('dataSources', {
  state: () => ({
    dataSources: [] as DataSource[],
  }),

  getters: {
    activeSources: (state) => {
      const activeSources: Record<CaseType, Set<CaseSourceName>> = { Person: new Set(), Business: new Set(), Asset: new Set() }
      const caseTypes: CaseType[] = ['Person', 'Business', 'Asset']
      for (const caseType of caseTypes) {
        for (const dataSource of state.dataSources) {
          if (dataSource.type !== caseType) {
            continue
          }

          if (dataSource.active) {
            activeSources[caseType].add(dataSource.source)
          }
        }
      }

      return activeSources
    },

    activeSourceNames: (state): CaseSourceName[] => {
      const activeSourceNames = new Set<CaseSourceName>()
      for (const dataSource of state.dataSources) {
        if (dataSource.active) {
          activeSourceNames.add(dataSource.source)
        }
      }

      return Array.from(activeSourceNames)
    },

    isSourceActive: (state) => (sourceName: CaseSourceName) => {
      return state.dataSources.some((dataSource) => dataSource.source === sourceName && dataSource.active)
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDataSources, import.meta.hot))
}
